import { Injectable } from "@angular/core";
import { UiBlockService } from "@ankaadia/ankaadia-shared-frontend";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class NewUiGlobalSpinnerService implements UiBlockService {
  private readonly showSubject = new BehaviorSubject<boolean>(false);

  readonly show$ = this.showSubject.asObservable();

  show(): void {
    this.showSubject.next(true);
  }

  hide(): void {
    this.showSubject.next(false);
  }
}
